import React, { useEffect, createElement } from 'react';
import { HeroSection } from './components/HeroSection';
import { EmpathySection } from './components/EmpathySection';
import { ProblemSection } from './components/ProblemSection';
import { MechanismSection } from './components/MechanismSection';
import { ProductRevealSection } from './components/ProductRevealSection';
import { WhatsInsideSection } from './components/WhatsInsideSection';
import { WhoItsForSection } from './components/WhoItsForSection';
import { FounderSection } from './components/FounderSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { DifferenceSection } from './components/DifferenceSection';
import { OfferSection } from './components/OfferSection';
import { FAQSection } from './components/FAQSection';
import { FinalCtaSection } from './components/FinalCtaSection';
import { Footer } from './components/Footer';
import { LanguageProvider } from './i18n/LanguageContext';
import { LanguageToggle } from './components/LanguageToggle';
import { UrgencyBanner } from './components/UrgencyBanner';
import { CONFIG } from './config';
export function App() {
  useEffect(() => {
    // Facebook domain verification meta tag
    try {
      if (typeof document !== 'undefined') {
        const existing = document.querySelector('meta[name="facebook-domain-verification"]');
        if (!existing) {
          const meta = document.createElement('meta');
          meta.name = 'facebook-domain-verification';
          meta.content = '3sjijbnphfroxidla9gjpbkihfts6q';
          document.head.appendChild(meta);
        }
      }
    } catch (e) {
      // Domain verification meta failed — non-critical
    }
    try {
      if (typeof window === 'undefined') return;
      if ((window as any).fbq) return;
      const n: any = (window as any).fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!(window as any)._fbq) (window as any)._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const t = document.createElement('script');
      t.async = true;
      t.src = 'https://connect.facebook.net/en_US/fbevents.js';
      const s = document.getElementsByTagName('script')[0];
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      } else {
        document.head.appendChild(t);
      }
      ;
      (window as any).fbq('init', CONFIG.tracking.metaPixelId);
      (window as any).fbq('track', 'PageView');
      (window as any).fbq('track', 'ViewContent', {
        content_name: CONFIG.product.name,
        content_ids: ['ai-income-blueprint'],
        content_type: 'product',
        content_category: 'Digital Product',
        value: CONFIG.product.price,
        currency: CONFIG.tracking.currency
      });
    } catch (e) {
      // Meta Pixel failed to initialize — non-critical, continue rendering
    }
  }, []);
  return <LanguageProvider data-id="element-0">
      <div className="min-h-screen bg-bg text-ink font-inter selection:bg-brand selection:text-black" data-id="element-1">
        <UrgencyBanner data-id="element-2" />
        <LanguageToggle data-id="element-3" />
        <HeroSection data-id="element-4" />
        <EmpathySection data-id="element-5" />
        <ProblemSection data-id="element-6" />
        <MechanismSection data-id="element-7" />
        <ProductRevealSection data-id="element-8" />
        <WhatsInsideSection data-id="element-9" />
        <WhoItsForSection data-id="element-10" />
        <FounderSection data-id="element-11" />
        <TestimonialsSection data-id="element-12" />
        <DifferenceSection data-id="element-13" />
        <OfferSection data-id="element-14" />
        <FAQSection data-id="element-15" />
        <FinalCtaSection data-id="element-16" />
        <Footer data-id="element-17" />
      </div>
    </LanguageProvider>;
}